import { nanoid } from "nanoid";
import classes from "../../../styles/Subscription.module.scss";
import tickIcon from "../../../assets/icons/tick.svg";
import CustomIcon from "../../../components/core/CustomIcon/CustomIcon";
import Button from "../../../components/core/Button/Button";
import { useNavigate } from "react-router-dom";
import { APP_PATH } from "../../../routes/route";

function PackageCard({ plan,planType, amount, userslimit, features = [] }) {
  const navigate = useNavigate();
  return (
    <div className={classes.packagesCont}>
      <div className={classes.planName}>{plan}</div>
      <div className={classes.amount}>
        ₹ {amount}
        <span> per month</span>
      </div>
      <div className={classes.userslimit}>{userslimit}</div>
      <div className={classes.featuresList}>
        <div className={classes.heading}>Access to basic features</div>
        {features.map(f => {
          return (
            <div className={classes.list} key={nanoid()}>
              <CustomIcon src={tickIcon} iconWidth={16} iconHeight={16} />
              <div className={classes.feature}>{f}</div>
            </div>
          );
        })}
      </div>
      <div className={classes.btnSection}>
        <Button
          label="Get Started"
          backgroundColor="#00BAF2"
          color="#FFFFFF"
          width="100%"
          clickHandler={() =>
            navigate(`${APP_PATH}/subscription/form`,
                          {state:{plan:plan,planType:planType}})
          }
        />
        {/* <Button
          label="Talk to sales"
          backgroundColor="#F1F5F9"
          color="#002970"
          width="100%"
        /> */}
      </div>
    </div>
  );
}
export default PackageCard;
